var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard__card" },
    [
      _vm.loaders.dashboardData ? _c("CardLoading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dashboard__card-content",
          class: { loadingBlur: _vm.loaders.dashboardData }
        },
        [
          _c("div", { staticClass: "dashboard__card-header" }, [
            _c("div", { staticClass: "dashboard__card-title" }, [
              _vm._v("Fuel Utilization")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "dashboard__card-title-addendum" }, [
              _vm._v(_vm._s(_vm.dateRangeText))
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "row dashboard__card-body dashboard__card-body--bordered"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "dashboard__grid dash-fuel-utilization__content-container"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-12 dashboard__card-body-col dashboard__card-body-col--shaded dashboard__card-body-col--fuel-utilization"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _vm.workOrders.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "dash-fuel-utilization__work-orders"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dash-fuel-utilization__recent-work-orders-header"
                                  },
                                  [_vm._v("Recent In Progress")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.workOrders, function(
                                  workOrder,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: workOrder.id,
                                      staticClass:
                                        "dash-fuel-utilization__work-order"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__work-order-name"
                                        },
                                        [_vm._v(_vm._s(workOrder.title))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dash-fuel-utilization__work-order-status",
                                          class: _vm.workOrderStatusClass(
                                            workOrder.portalStatus
                                          )
                                        },
                                        [_vm._v(_vm._s(workOrder.portalStatus))]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _c("div", { staticClass: "alert alert-warning" }, [
                              _c("div", { staticClass: "dashboard__no-data" }, [
                                _vm._v("No recent work order activity")
                              ])
                            ])
                      ])
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard__card-footer" }, [
            _c(
              "div",
              { staticClass: "dashboard__card-link" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "dashboard__card-link-text",
                    attrs: { to: "/fuel-utilization" }
                  },
                  [_vm._v("View All")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "dashboard__card-title-icon dashboard__card-title-icon--fuel-utilization"
      },
      [_c("i", { staticClass: "fa fa-tasks" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }